import { clickHandler } from '@/ui/scripts/analytics/analytics.methods';

const eventName = 'documentDownload_tracking';
const actionPropTitle = 'documentDownload_action';
const labelPropTitle = 'documentDownload_label';

const documentDownloadComponents = [...document.querySelectorAll('.js-document-download-ga')];
const linkClass = '.js-document-download-link-ga';

function bindEventListener(el) {
  el.addEventListener('click', (e) => {
    clickHandler(
      {
        event: eventName,
        actionProp: actionPropTitle,
        labelProp: labelPropTitle,
        action: 'Click',
        label: el.innerText,
      },
      e,
    );
  });
}

function init() {
  if (!documentDownloadComponents.length && document.querySelector(linkClass)) {
    return;
  }

  documentDownloadComponents.forEach((comp) => {
    const links = comp.querySelectorAll(linkClass);
    links.forEach((el) => bindEventListener(el));
  });
}

export default init;
